import { toFixed4 } from '../components/DexTrades/formatters';
import {
  contentColors,
  ITableCard,
  RowItemValue,
} from '../molecules/Table/mobile/TableCard';

/**
 * Universal formatted to be used all across the app
 * @param input - string or number
 */
const formatAmount = (input: string | number): string => {
  let value: number;
  if (typeof input === 'string') {
    value = parseFloat(input);
  } else {
    value = input;
  }
  if (value < 1.0) {
    return value.toFixed(8);
  } else {
    if (value.toFixed(2).length < 10) {
      const strLen = value.toFixed(2).length;
      return value.toFixed(12 - strLen);
    } else {
      return value.toFixed(2);
    }
  }
};

const scienceDeformat = (number: number | string) =>
  number.toLocaleString('fullwide');

const formatAPY = (apy: number): string =>
  apy < 0.01 ? '<0.01%' : `${toFixed4(apy)}%`;

export interface IMobileTableScema {
  [key: string]: {
    [key: string]: {
      name?: string;
      accessor: string;
      color?: contentColors;
      parser?(value: any, row?: any, index?: number): RowItemValue;
      onClick?(row: any): void;
      width?: number;
    };
  };
}

type formatMobileTableDataArgs = {
  data: any;
  schema: IMobileTableScema;
  getColorForItem: (row: any) => string;
  renderFooter?: (data: any) => JSX.Element;
  footerData?: any;
  handleCardClick?: (data: any) => void;
  keyName?: string;
};

const formatMobileTableData = ({
  data,
  schema,
  getColorForItem,
  renderFooter,
  footerData,
  handleCardClick,
  keyName,
}: formatMobileTableDataArgs): ITableCard[] => {
  return data.map((element: any, elIndex: number) => ({
    card: Object.values(schema).map((row) =>
      Object.values(row).map((item, index) => {
        const itemValue = item.parser
          ? item.parser(element[item.accessor], element, elIndex)
          : element[item.accessor];
        const itemColor = item.color ? item.color : getColorForItem(element);
        const itemHandleClick = item.onClick
          ? () => item.onClick!(element)
          : undefined;
        const fulfilledItem = {
          name: item.name,
          content: { value: itemValue, color: itemColor },
          width: item.width,
          handleClick: itemHandleClick,
          id: index,
        };
        return fulfilledItem;
      })
    ),
    footer:
      renderFooter && footerData
        ? renderFooter({ data: element, ...footerData })
        : undefined,
    onCardClick: handleCardClick ? () => handleCardClick(element) : undefined,
    key: keyName ? element[keyName] : elIndex,
  }));
};

const formatAddress = (address: string) =>
  address.slice(0, 6) +
  '...' +
  address.slice(address.length - 4, address.length);

const formatTokenName = (token: string) => {
  if (token.length > 4) {
    return token.slice(0, 4) + '...';
  }

  return token;
};

export {
  formatAmount,
  scienceDeformat,
  formatAPY,
  formatMobileTableData,
  formatAddress,
  formatTokenName,
};
